import * as React from 'react';
import { Translate, I18n } from 'react-redux-i18n';

import Popup from '../../../Popup';
import { PopupBodyWrapper, Button } from './styles';

interface ShareActionPopupProps {
	isDisplayed: boolean;
	onShareViaCopy: () => void;
	onShareViaUprez: () => void;
	onCancel: () => void;
	isProcessing?: boolean;
	label?: string;
	actionButtonColor?: string;
}

const ShareActionPopup = ({
	isDisplayed,
	isProcessing,
	onShareViaCopy,
	onShareViaUprez,
	onCancel,
	label,
	actionButtonColor,
}: ShareActionPopupProps) => (
	<Popup
		isDisplayed={isDisplayed}
		isLoading={isProcessing}
		label={label || I18n.t('messages.share')}
		actionButtonColor={actionButtonColor}
		onCancel={onCancel}
		gallerySlot="shareForm"
	>
		<PopupBodyWrapper>
			<Button
				type="button"
				onClick={onShareViaCopy}
			>
				<Translate value="messages.share_via_copy" />
			</Button>
			<Button
				type="button"
				onClick={onShareViaUprez}
			>
				<Translate value="messages.share_via_uprez" />
			</Button>
		</PopupBodyWrapper>
	</Popup>
);

export default ShareActionPopup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/UprezForm/ShareActionPopup/index.tsx